import axios from 'axios';

export const actions = {
    loadTour({commit}, id) {
        commit('setPending', true);
        axios.get(`/api/fetch-travel-data/tour/${id}`)
            .then(response => {
                return response.data[0];
            })
            .then(route => {
                commit('setRoute', route);
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    loadCountry({commit}, id) {
        commit('setPending', true);
        axios.get(`/api/fetch-travel-data/country/${id}`)
            .then(response => {
                return response.data[0];
            })
            .then(country => {
                commit('setCountry', country);
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    submitForm({commit}, form) {
        commit('setPending', true);
        form.budget = `${form.budget[0]}, ${form.budget[1]}`;

        const data = JSON.stringify(form);
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: '/api/inquiry',
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        };

        return axios(config)
            .then(response => {
                return response.data[0]
            })
            .then(inquiry => {
                commit('setInquiry', inquiry);
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    },

    submitPhone({commit}, phoneForm) {
        commit('setPending', true);

        const data = JSON.stringify(phoneForm);
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: '/api/inquiry/phone',
            headers: {
                'Content-Type': 'application/json',
            },
            data : data
        };

        return axios(config)
            .then(response => {
                return response.data;
            })
            .then(route => {
                route.messagesForTraveller.reverse();
                commit('setRoute', route);
            })
            .catch(err => {
                commit('setError', err);
            })
            .finally(() => {
                commit('setPending', false);
            });
    }
};